import {iLoginData} from "../../model/authentication/LoginPageInterface";
import {requests} from "../../utils/helpers/api.services";
import {BASE_PATH} from "../../utils/helpers/api.routes";
import {ErrorToast} from "../../utils/toasters/toasters";

export function SignIn(body: iLoginData) {
    return requests.post(`${BASE_PATH}/signin`, body)
        .then(data => data)
        .catch(error => ErrorToast(error));
}